import { render, staticRenderFns } from "./PageContacts.vue?vue&type=template&id=153eac45&"
import script from "./PageContacts.vue?vue&type=script&lang=js&"
export * from "./PageContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports